import axios from 'axios'
import { getServerUrl } from '../../../functions/getServerUrl'

import { getNotifications } from '../../notifications/reducers/notificationsReducer'

let defaultState = {
  authenticatingUser: false,
  loggedIn: false,
  currentUser: null,
  prevLocation: null,
  errorMessage: '',
  apiAccess: true,
}


export default function loginReducer (state = defaultState, action) {
  switch (action.type) {
    case "AUTHENTICATING_USER":
      return {
        ...state,
        authenticatingUser: true,
        prevLocation: action.payload,
      }
    case "SET_CURRENT_USER":
      return {
        ...state,
        authenticatingUser: false,
        loggedIn: true,
        currentUser: action.payload,
      }
    case "SET_API_ACCESS":
      return { ...state, apiAccess: action.payload }
    case "LOG_OUT_USER":
      return {
        ...state,
        loggedIn: false,
        currentUser: null,
        authenticatingUser: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export const checkAPIAccess = () => {
  return (dispatch) => {
    axios.get(`${getServerUrl()}/check-access/`)
    .then((response) => {
      dispatch({ type: "SET_API_ACCESS", payload: true })
    })
    .catch(error => {
      dispatch({ type: "SET_API_ACCESS", payload: false })
    })
  }
}

export const fetchCurrentUser = (prevLocation) => {
  return (dispatch) => {
    dispatch({type: "AUTHENTICATING_USER", payload: prevLocation})
    axios({
      method: "GET",
      url: `${getServerUrl()}/token-check`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then((response) => {
      dispatch(getNotifications())
      dispatch(setUser(response.data))
    })
    .catch(error => {
      let message = ''
      if (error && error.response && error.response.status === 401) {
        message = 'Your session has expired. Please log back in.'
      }
      return dispatch(logOutUser(message))
    })
  }
}

export const setUser = (user) => {
  if (user && user.sites && Array.isArray(user.sites)) {
    const sites = user.sites.map(site => {
      if (site.region === 'default') {
        return {
          ...site,
          region: 'US',
        }
      }
      return site
    })

    user = {...user, sites}
  }

  return {type: "SET_CURRENT_USER", payload: user}
}

export const logInUser = (user) => {
  return (dispatch) => {
    dispatch({type: "AUTHENTICATING_USER"})
    const { username, password } = user

    let message = ''

    if (!username || !password) {
      message = 'Please enter username and password'
      return dispatch(logOutUser(message))
    }

    axios({
      method: "POST",
      url: `${getServerUrl()}/login/`,
      data: { username, password },
    })
    .then(response => {
      localStorage.setItem('jwt', response.data.token)
      const user = { ...response.data.user, id: response.data.user.pk }
      dispatch(getNotifications())
      return dispatch(setUser(user))
    })
    .catch(error => {
      if (error && error.response && error.response.status === 400) {
        message = 'Could not log in with provided credentials'
      } else if (error && !error.response) {
        message = 'The server is down.'
      } else {
        message = 'Could not log in at this time.'
      }
      return dispatch(logOutUser(message))
    })
  }
}


export const logOutUser = (message) => {
  if (typeof message !== 'string') {
    message = ''
  }
  return (dispatch) => {
    localStorage.clear()
    window.location = "#/login"
    return dispatch({ type: "LOG_OUT_USER", payload: message })
  }
}
